import { User } from '@/store/user.ts'
import { LocallyStoredFilterT } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'
import { queryClient } from '@/lib/api-client.ts'
import {
  GetProjectsParticipationsReturnT,
  userProjectParticipationsQuery,
} from '@/lib/actions/getUserProjectParticipations.ts'
import { validateLastActiveStageId } from '@/routes/login/validateLastActiveStageId.tsx'
import { findStoredTab } from '@/lib/helpers/findStoredTab.ts'
import { InfiniteData } from '@tanstack/react-query'

type NavigateToPropsT = {
  user: User
  navigate: (path: string) => void
  tabs: LocallyStoredFilterT[]
}

export async function redirectToLastActivePath({ user, tabs, navigate }: NavigateToPropsT) {
  const queryOptions = userProjectParticipationsQuery()

  // Try to get cached data first, then fetch if online
  let participationsData: InfiniteData<GetProjectsParticipationsReturnT | undefined> | undefined

  if (!navigator.onLine) {
    // Offline: use cached data only
    participationsData = queryClient.getQueryData(queryOptions.queryKey)
    if (!participationsData) {
      console.log(
        '[redirectToLastActivePath] Offline with no cached participations, staying on current page',
      )
      return
    }
  } else {
    // Online: try to fetch, fallback to cache on error
    try {
      participationsData = await queryClient.fetchInfiniteQuery(queryOptions)
    } catch (error) {
      console.error('[redirectToLastActivePath] Fetch failed:', error)
      participationsData = queryClient.getQueryData(queryOptions.queryKey)
      if (!participationsData) {
        console.log('[redirectToLastActivePath] No cached data available')
        return
      }
    }
  }

  const userId = user.id
  const userProjectParticipations = participationsData.pages[0]?.projectParticipations

  const stageId = validateLastActiveStageId(
    userProjectParticipations,
    user.activeProjectStage,
    // true,
  )
  if (!stageId) {
    console.log(stageId, '!stageId navigating to account')
    return navigate(`/settings/account`)
  }

  const storedLink = findStoredTab(tabs, userId, stageId)
  // console.log({ storedLink })

  if (storedLink) {
    console.log(`navigating to stored link: ${storedLink}`)
    navigate(storedLink)
  } else {
    console.log(` no stored link found navigating to dashboard: ${stageId}`)
    navigate(`/project_stages/${stageId}/dashboard`)
  }
}
